module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.auth.list) ? _c('div', {
    staticClass: "snList"
  }, [_c('el-form', {
    ref: "searchForm",
    attrs: {
      "model": _vm.search,
      "size": "mini",
      "inline": true,
      "label-position": _vm.position
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "小码",
      "clearable": ""
    },
    model: {
      value: (_vm.search.sn),
      callback: function($$v) {
        _vm.$set(_vm.search, "sn", $$v)
      },
      expression: "search.sn"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "组织",
      "clearable": ""
    },
    model: {
      value: (_vm.search.orgId),
      callback: function($$v) {
        _vm.$set(_vm.search, "orgId", $$v)
      },
      expression: "search.orgId"
    }
  }, _vm._l((_vm.orgList), function(item) {
    return _c('el-option', {
      key: item.deptId,
      attrs: {
        "label": item.deptName,
        "value": item.deptId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searcherSubmit
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 10
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.snList,
      "border": "",
      "fit": true,
      "header-cell-style": {
        'text-align': 'center'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "materialNumber",
      "label": "物料编码",
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "materialName",
      "label": "物料名称",
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "modelName",
      "label": "物料型号",
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseName",
      "label": "所属仓库",
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "warehouseTypeName",
      "label": "仓库类型",
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sn",
      "label": "物料小码",
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.getLife(scope.row)
            }
          }
        }, [_vm._v("生命周期")])]
      }
    }], null, false, 3121629848)
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "align": "left",
      "current-page": _vm.pages.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.pages.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pages.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.centerDialogVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('el-timeline', {
    attrs: {
      "reverse": true
    }
  }, _vm._l((_vm.lifeList), function(activity, index) {
    return _c('el-timeline-item', {
      key: index,
      attrs: {
        "timestamp": activity.createtime
      }
    }, [_c('el-card', [_c('h4', [_vm._v(_vm._s(activity.opeContent) + ",单据编码:"), _c('span', {
      staticStyle: {
        "color": "#d82c10"
      },
      on: {
        "click": function($event) {
          return _vm.handleCopy(activity.lineOrderNumber, $event)
        }
      }
    }, [_vm._v(_vm._s(activity.lineOrderNumber))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(activity.createUser) + " 提交于 " + _vm._s(_vm.dateFormat(activity.createTime)))])])], 1)
  }), 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-58f06f15","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/storehouseManage/snList.vue
// module id = 1676
// module chunks = 0